<template lang="pug">
.vue-location
  loader(v-if="loading === true")
  template(v-else)
    detail(:settings="settings")
    services
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import loader from "./components/loader";
import detail from './components/detail';
import services from './components/services';

export default {
  name: 'Location Detail',
  components: {
    loader,
    detail,
    services
  },
  data() {
    return {
      settings: { ...document.querySelector('#vue-location-detail').dataset }
    };
  },
  computed: {
    ...mapGetters(["config", "loading"]),
  },
  methods: {
    ...mapActions(["loadConfig", "loadDetails"]),
  },
  async created() {
    await this.loadConfig(this.settings.config);
    await this.loadDetails(this.settings.details)
  },
}
</script>

<style lang="scss" scoped>
.vue-location {
  @include container();
}
</style>
